module.exports = __webpack_public_path__ + "img/game_main_pc_27_off.513271ae.png";